// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__xDkS9","consentsList":"PatientConsents_consentsList__1gBMk","consentsListEmpty":"PatientConsents_consentsListEmpty__zb9SG"};